// imports
import React from 'react';
import { Flex } from '@withjoy/joykit';
import { pxToRem } from '@withjoy/joykit/theme';

// local imports
import { CTAButton } from '../CTAButton';
import { useTranslation } from '@shared/core';
import { hasAccommodationLink } from '../../../Accommodations/Accommodation.utils';
import { AccommodationCombined } from '../../../Accommodations/Accommodation.types';

type CTAButtonsSectionProps = Readonly<{
  onViewJoyRates: () => void;
  isViewJoyRatesDisabled: boolean;
  onOpenExternalLink?: React.MouseEventHandler;
  accommodation: AccommodationCombined;
}>;

export const CTAButtonsSection: React.FC<CTAButtonsSectionProps> = React.memo(({ accommodation, onViewJoyRates, onOpenExternalLink, isViewJoyRatesDisabled }) => {
  const { t } = useTranslation('guestSiteCustom');
  const accTrans = t('accommodations');

  const hasLink = hasAccommodationLink(accommodation.isCustomLinkEnabled, accommodation.customUrl);

  return (
    <Flex
      gap={pxToRem(24)}
      marginTop={pxToRem(24)}
      flexDirection="column"
    >
      <CTAButton
        width="100%"
        variant="solid"
        fontFamily={'Inter UI'}
        onClick={onViewJoyRates}
        disabled={isViewJoyRatesDisabled}
        ctaTitle={accTrans.linkInterceptor.viewJoyRates()}
      />
      {hasLink && (
        <CTAButton
          width="100%"
          variant="link"
          fontFamily={'Inter UI'}
          typographyVariant="button2"
          onClick={onOpenExternalLink}
          ctaTitle={accTrans.linkInterceptor.openExternalLink()}
        />
      )}
    </Flex>
  );
});

CTAButtonsSection.displayName = 'CTAButtonsSection';
